import { render, staticRenderFns } from "./media-preview.vue?vue&type=template&id=43fc899a&scoped=true"
import script from "./media-preview.vue?vue&type=script&lang=ts"
export * from "./media-preview.vue?vue&type=script&lang=ts"
import style0 from "./media-preview.vue?vue&type=style&index=0&id=43fc899a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc899a",
  null
  
)

export default component.exports